import { createFileRoute } from '@tanstack/react-router';

// The list grid lives in the parent `assets` layout route so it stays
// mounted behind the `$assetId` lightbox overlay; this leaf renders nothing.
export const Route = createFileRoute('/_authenticated/assets/')({
  component: () => null,
});
